import React from "react";
import { ReactSVG } from "react-svg";

/**
 * Bara de taburi din popup-urile de profil (elev, instructor, personal):
 * iconiță deasupra, text mic dedesubt, ca într-un tab bar iOS — încap mai
 * multe taburi pe aceeași linie. items: [{ key, label, icon, badge? }]
 */
export default function ProfileTabs({
   items = [],
   value,
   onChange,
   className = "",
   "aria-label": ariaLabel = "Secțiuni profil",
}) {
   const list = Array.isArray(items) ? items.filter(Boolean) : [];
   if (!list.length) return null;

   return (
      <div
         className={"profileTabs" + (className ? ` ${className}` : "")}
         role="tablist"
         aria-label={ariaLabel}
      >
         {list.map((item) => {
            const active = item.key === value;
            const badge = Number(item.badge) || 0;
            return (
               <button
                  key={item.key}
                  type="button"
                  role="tab"
                  aria-selected={active}
                  className={"profileTabs__tab" + (active ? " is-active" : "")}
                  onClick={() => onChange?.(item.key)}
                  title={item.label}
               >
                  <span className="profileTabs__iconWrap">
                     {item.icon ? (
                        <ReactSVG
                           src={item.icon}
                           className="profileTabs__icon"
                           wrapper="span"
                        />
                     ) : null}
                     {badge > 0 ? (
                        <span className="profileTabs__badge" aria-hidden="true">
                           {badge > 99 ? "99+" : badge}
                        </span>
                     ) : null}
                  </span>
                  <span className="profileTabs__label">{item.label}</span>
               </button>
            );
         })}
      </div>
   );
}
